import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useTermsOfServiceTextContent } from '@euler/functions/tos/useTermsOfServiceTextContent';
import { useStoreConfiguration } from '@euler/functions/useStoreConfiguration';
import { memo } from 'react';
import { Text, View } from 'react-native';
import { OrderInfoSection as Section } from './Section';

export const TermsOfServiceSection = memo(() => {
  const { rpx } = useResponsiveContext();
  const storeConfiguration = useStoreConfiguration();
  const content = useTermsOfServiceTextContent(
    storeConfiguration.serviceAgreement?.content,
  );

  return (
    <Section title="售后服务协议">
      <View
        css={`
          padding: ${rpx(15)}px;
        `}
      >
        <Text
          numberOfLines={0}
          css={`
            font-family: ${FontFamily.NotoSans.Regular};
            font-size: ${rpx(16)}px;
            line-height: ${rpx(21)}px;
            color: rgb(80, 76, 76);
          `}
        >
          {content ?? ''}
        </Text>
      </View>
    </Section>
  );
});
